/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var KlaviyoFormComponent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(KlaviyoFormComponent, _HTMLElement);
  var _super = _createSuper(KlaviyoFormComponent);
  function KlaviyoFormComponent() {
    _classCallCheck(this, KlaviyoFormComponent);
    return _super.call(this);
  }
  _createClass(KlaviyoFormComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.form = this.querySelector('.form-klaviyo-newsletter');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this = this;
      event.preventDefault();
      // Add any additional logic or validation here

      var emailInput = this.form.querySelector('input[name="contact[email]"]').value;
      var firstNameInput = this.form.querySelector('input[name="contact[first_name]"]');
      var lastNameInput = this.form.querySelector('input[name="contact[last_name]"]');
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=RvarJd';

      // Build profile attributes
      var profileAttributes = {
        email: emailInput,
        subscriptions: {}
      };

      // Handle name fields - check if split name fields exist
      if (lastNameInput && lastNameInput.value.trim() !== '') {
        // Split name mode - send first_name and last_name
        if (firstNameInput && firstNameInput.value.trim() !== '') {
          profileAttributes.first_name = firstNameInput.value.trim();
          profileAttributes.last_name = lastNameInput.value.trim();
        }
      } else if (firstNameInput && firstNameInput.value.trim() !== '') {
        // Single name field mode - send as properties with full_name
        profileAttributes.properties = {
          full_name: firstNameInput.value.trim()
        };
      }
      var data = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "XNJC5Z"
              }
            }
          }
        }
      };
      fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/vnd.api+json',
          'revision': '2026-01-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(data)
      }).then(function (data) {
        if (data.ok) {
          _this.querySelector('.form_on_success .newsletter__message ').style.display = "block";
          _this.querySelector('.fieldset-with-submit').style.display = "none";
        } else {
          _this.querySelector('.form_on_danger .newsletter__message ').style.display = "block";
          var submitButton = _this.form.querySelector('button[type="submit"]');
        }
      })["catch"](function (errors) {
        _this.querySelector('.form_on_danger .newsletter__message ').style.display = "block";
        var submitButton = _this.form.querySelector('button[type="submit"]');
        submitButton.setAttribute('aria-busy', 'false');
      });
    }
  }]);
  return KlaviyoFormComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('form-klaviyo-newsletter', KlaviyoFormComponent);

/**
 * Quantity Selector Web Component
 * Handles quantity selector functionality on product pages
 */
if (!customElements.get('quantity-selector')) {
  var QuantitySelector = /*#__PURE__*/function (_HTMLElement2) {
    _inherits(QuantitySelector, _HTMLElement2);
    var _super2 = _createSuper(QuantitySelector);
    function QuantitySelector() {
      var _this2;
      _classCallCheck(this, QuantitySelector);
      _this2 = _super2.call(this);
      _this2.init();
      return _this2;
    }
    _createClass(QuantitySelector, [{
      key: "init",
      value: function init() {
        this.items = this.querySelectorAll('.quantity-selector__item');
        this.setupEventListeners();
        this.setupQuantityChangeListener();
        this.setupVariantChangeListener();
      }
    }, {
      key: "setupEventListeners",
      value: function setupEventListeners() {
        var _this3 = this;
        // Add click event listeners to each item
        this.items.forEach(function (item) {
          item.addEventListener('click', _this3.handleItemClick.bind(_this3));
        });
      }
    }, {
      key: "setupVariantChangeListener",
      value: function setupVariantChangeListener() {
        var _this4 = this;
        // Listen for variant changes to reset the stored base price
        var section = this.closest('product-info');
        if (section) {
          var variantIdInput = section.querySelector('input[name="id"]');
          if (variantIdInput) {
            // Use MutationObserver to detect when variant ID changes
            var observer = new MutationObserver(function () {
              // Clear stored price when variant changes
              delete section.dataset.originalBasePrice;
              delete section.dataset.originalPriceVariantId;
              console.log('Variant changed - cleared stored price');

              // Reapply discount if one is active
              var discount = section.dataset.quantityDiscount;
              if (discount) {
                requestAnimationFrame(function () {
                  _this4.updateButtonPriceWithDiscount(section, discount);
                });
              }
            });
            observer.observe(variantIdInput, {
              attributes: true,
              attributeFilter: ['value']
            });
          }
        }
      }
    }, {
      key: "setupQuantityChangeListener",
      value: function setupQuantityChangeListener() {
        var _this5 = this;
        // Listen for quantity changes to reapply discount
        var section = this.closest('product-info');
        if (section) {
          var productForm = section.querySelector('product-form');
          if (productForm) {
            var quantityInput = productForm.querySelector('input[name="quantity"]');
            if (quantityInput) {
              quantityInput.addEventListener('change', function () {
                // Reapply discount if one is stored
                var discount = section.dataset.quantityDiscount;
                if (discount && discount !== '0') {
                  requestAnimationFrame(function () {
                    _this5.updateButtonPriceWithDiscount(section, discount);
                  });
                }
              });
            }
          }
        }
      }
    }, {
      key: "handleItemClick",
      value: function handleItemClick(event) {
        var _this6 = this;
        var item = event.currentTarget;

        // Toggle active state
        this.items.forEach(function (i) {
          return i.classList.remove('active');
        });
        item.classList.add('active');

        // Get quantity and discount from the clicked item data attributes
        var quantity = item.dataset.quantityItem;
        var discount = item.dataset.discountItem || '0';
        if (quantity) {
          // Find the closest section and update the quantity input
          var section = this.closest('product-info');
          if (section) {
            // Store discount percentage on the product-info element
            section.dataset.quantityDiscount = discount;
            var productForm = section.querySelector('product-form');
            if (productForm) {
              var quantityInput = productForm.querySelector('input[name="quantity"]');
              if (quantityInput) {
                quantityInput.value = quantity;
                // Trigger change event to update the button price
                quantityInput.dispatchEvent(new Event('change', {
                  bubbles: true
                }));
              }
            }

            // Wait for the theme's updateButtonPrice to run, then apply discount
            requestAnimationFrame(function () {
              _this6.updateButtonPriceWithDiscount(section, discount);
            });
          }
        }
      }
    }, {
      key: "updateButtonPriceWithDiscount",
      value: function updateButtonPriceWithDiscount(section, discountPercent) {
        console.log('updateButtonPriceWithDiscount called', {
          section: section,
          discountPercent: discountPercent
        });
        var priceElement = section.querySelector('[data-product-price]');
        console.log('priceElement found:', priceElement);
        if (!priceElement) {
          console.error('Price element not found');
          return;
        }
        var discount = parseFloat(discountPercent) || 0;
        console.log('Discount parsed:', discount);

        // Get the current variant price from the selected variant input
        var variantIdInput = section.querySelector('input[name="id"]');
        if (!variantIdInput || !variantIdInput.value) {
          console.error('Variant ID input not found');
          return;
        }
        var variantId = parseInt(variantIdInput.value);
        console.log('Variant ID:', variantId);

        // Get quantity
        var quantityInput = section.querySelector('input[name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;
        console.log('Quantity:', quantity);
        var basePrice = null;

        // Check if we have a stored original price for this variant
        var storedVariantId = section.dataset.originalPriceVariantId;
        var storedBasePrice = section.dataset.originalBasePrice;
        if (storedVariantId === String(variantId) && storedBasePrice) {
          // Use the stored base price
          basePrice = parseInt(storedBasePrice);
          console.log('Using stored base price:', basePrice);
        } else {
          // Get variant data from window.productVariants
          if (window.productVariants && Array.isArray(window.productVariants)) {
            var variant = window.productVariants.find(function (v) {
              return v.id === variantId;
            });
            if (variant && variant.price) {
              basePrice = variant.price;
              console.log('Price from window.productVariants:', basePrice, 'for variant:', variant.title);
            } else {
              console.warn('Variant not found in window.productVariants');
            }
          } else {
            console.warn('window.productVariants not available');
          }

          // Fallback: try variant option data attribute
          if (!basePrice) {
            var variantOption = section.querySelector("option[value=\"".concat(variantId, "\"]"));
            if (variantOption && variantOption.dataset.price) {
              basePrice = parseInt(variantOption.dataset.price);
              console.log('Price from variant option:', basePrice);
            }
          }

          // Last fallback: parse from current button text (only on first load)
          if (!basePrice) {
            var currentPriceText = priceElement.textContent || priceElement.innerHTML;
            console.log('Current price text:', currentPriceText);

            // Try to extract the price number from the text (remove currency symbols and commas)
            var priceMatch = currentPriceText.replace(/[^0-9.,]/g, '').replace(',', '');
            if (priceMatch) {
              // Convert to cents (multiply by 100)
              var priceValue = parseFloat(priceMatch);
              // Divide by quantity to get base price per item
              basePrice = Math.round(priceValue * 100 / quantity);
              console.log('Price parsed from text:', basePrice);
            }
          }

          // Store the base price and variant ID
          if (basePrice) {
            section.dataset.originalBasePrice = basePrice;
            section.dataset.originalPriceVariantId = String(variantId);
            console.log('Stored base price:', basePrice, 'for variant:', variantId);
          }
        }
        if (!basePrice || isNaN(basePrice)) {
          console.error('Could not determine base price');
          return;
        }
        console.log('Base price (in cents):', basePrice);

        // Calculate discounted price
        var discountMultiplier = (100 - discount) / 100;
        var discountedPrice = Math.round(basePrice * discountMultiplier);
        var totalPrice = discountedPrice * quantity;
        console.log('Calculated prices:', {
          basePrice: basePrice,
          discountedPrice: discountedPrice,
          totalPrice: totalPrice,
          discountMultiplier: discountMultiplier
        });

        // Format price using theme's money format
        var formatMoney = function formatMoney(cents) {
          var _window$theme, _window$theme$strings, _window$theme2;
          if (cents === 0) return ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$strings = _window$theme.strings) === null || _window$theme$strings === void 0 ? void 0 : _window$theme$strings.free) || 'Free';
          if ((_window$theme2 = window.theme) !== null && _window$theme2 !== void 0 && _window$theme2.formatMoney) {
            return window.theme.formatMoney(cents, window.theme.moneyFormat);
          }
          // Fallback formatting
          return "$".concat((cents / 100).toFixed(2));
        };
        var formattedPrice = formatMoney(totalPrice);
        console.log('Formatted price:', formattedPrice);

        // Update button price with discounted price only
        priceElement.innerHTML = formattedPrice;
        console.log('Price element updated');
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        // Called when element is added to the DOM
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _this7 = this;
        // Cleanup when element is removed
        this.items.forEach(function (item) {
          item.removeEventListener('click', _this7.handleItemClick);
        });
      }
    }]);
    return QuantitySelector;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  customElements.define('quantity-selector', QuantitySelector);
}

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;